import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=029c1a34&scoped=true&"
import script from "./BasicTable.vue?vue&type=script&lang=js&"
export * from "./BasicTable.vue?vue&type=script&lang=js&"
import style0 from "./BasicTable.vue?vue&type=style&index=0&id=029c1a34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029c1a34",
  null
  
)

export default component.exports